import {gql} from "@apollo/client";

const CORE_SEVERITY_FIELDS = gql`
  fragment CoreSeveritySchemaFields on IncidentSeverity {
    id
    name
    description
    ordering
    backgroundColor
    foregroundColor
    isDeleted
  }
`;

export const GET_SEVERITIES = gql`
  ${CORE_SEVERITY_FIELDS}
  query GetSeverities {
    incidentSeverities(orderBy: {ordering: desc}) {
      ...CoreSeveritySchemaFields
      inUseBy {
        model
        count
      }
    }
  }
`;

export const CREATE_INCIDENT_SEVERITY = gql`
  ${CORE_SEVERITY_FIELDS}
  mutation CreateIncidentSeverity(
    $name: String!
    $description: String!
    $ordering: Int
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneIncidentSeverity(
      data: {
        name: $name
        description: $description
        ordering: $ordering
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      ...CoreSeveritySchemaFields
    }
  }
`;
export const UPDATE_INCIDENT_SEVERITY = gql`
  ${CORE_SEVERITY_FIELDS}
  mutation UpdateIncidentSeverity(
    $id: Int!
    $name: String!
    $description: String!
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneIncidentSeverity(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      ...CoreSeveritySchemaFields
    }
  }
`;

export const SOFT_DELETE_INCIDENT_SEVERITY = gql`
  ${CORE_SEVERITY_FIELDS}
  mutation SoftDeleteIncidentSeverity($id: Int!) {
    deleteOneIncidentSeverity(where: {id: $id}) {
      ...CoreSeveritySchemaFields
    }
  }
`;
export const DECREMENT_INCIDENT_SEVERITIES = gql`
  mutation DecrementIncidentSeverities($ordering: Int!) {
    updateManyIncidentSeverity(
      where: {ordering: {gt: $ordering}}
      data: {ordering: {decrement: 1}}
    ) {
      count
    }
  }
`;
export const REORDER_SEVERITIES = gql`
  mutation ReorderSchemaItems($items: [OrderItemType!], $schemaName: String!) {
    orderManyItems(items: $items, schemaName: $schemaName)
  }
`;
